var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoBbucleRoad = function SvgLogoBbucleRoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 43,
    fill: "none",
    viewBox: "0 0 95 43"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 595,
    height: 56,
    x: -352,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M242.169 7.707 15.044 26.633l-.677 8.11-3.244.272.677-8.113-363.102 30.264.344-3.264L55.872 20.01l.271-3.245 3.245-.27-.271 3.243L242.438 4.463zM44.246 33.865l-16.223 1.352-.134 1.624 16.222-1.353-.27 3.245-19.468 1.622.675-8.11 16.222-1.353.137-1.623-12.978 1.083-3.245.268.27-3.244 3.244-.27 16.223-1.351zM23.558 21.092 4.091 22.715 4.97 12.17l3.245-.272-.202 2.434 4.867-.406.202-2.433 3.245-.271-.202 2.432 4.868-.405.2-2.433 3.244-.27zm21.906-1.826-3.245.27.202-2.434-16.223 1.352.27-3.245 16.224-1.352.134-1.622-16.223 1.353.27-3.245L46.34 8.72zM7.743 17.574l-.135 1.623 4.868-.405.135-1.623zm8.11-.677-.134 1.624 4.868-.406.134-1.624zm74.02-8.585L73.65 9.663l-.339 4.057 16.224-1.353-.272 3.245-19.467 1.623.879-10.546 19.467-1.623zm-21.9 1.827L51.748 11.49l-.135 1.623 16.224-1.352-.272 3.245-19.467 1.62.676-8.11L65 7.166l.135-1.623-12.979 1.083-3.245.27.272-3.246 3.244-.268 16.223-1.353z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.867 8.1 91.895-.622l-3.042 35.496L.825 43.798z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h94.113v43H0z"
  })))));
};
export default SvgLogoBbucleRoad;